import { mapState } from 'vuex';

export default {
    computed: {
        ...mapState({
            promotions: (state) => state.promotions?.data || [],
            currentPageId: (state) => state.pages?.page?.id,
            currentLocale: (state) => state.geolocation?.desiredLocale || state.geolocation?.requestedLocale || '',
        }),

        hasEmailPromo() {
            const coupon = this.$route.query?.coupon || '';
            if (!coupon) return false;

            if (!this.$route.path.includes('purchasing')) return false;

            const productID = this.purchasePageCTA?.productId || this.internalProductId;
            const promotionForEmails = this.findPromotionForEmails(productID, coupon);
            return promotionForEmails.discount > 0;
        },

        promotionList() {
            const coupon = this.$route.query?.coupon || '';
            const isForEmailsOnly = this.hasEmailPromo;

            return this.promotions.filter((item) => {
                if (item.is_in_app_only) {
                    if (!this.isInapp) return false;
                    if (!item.locales?.length) return true;
                    return item.locales.some((l) => l.locale === this.currentLocale);
                }
                if (item.is_for_targeted_pages_only) {
                    return item.pages?.some((p) => p.page_id === this.currentPageId);
                }
                if (!isForEmailsOnly) return !item.is_for_emails_only;
                return item.is_for_emails_only && item.coupon_code === coupon;
            });
        },
    },

    methods: {
        promotionActive(productID) {
            if (!productID) return {};
            return this.promotions
                .filter((item) => !item.is_for_emails_only && !item.is_in_app_only && !item.is_for_targeted_pages_only)
                .find((item) => item.product_id === productID) || {};
        },

        findPromotion(productId, cleverBridgeCartIDs) {
            if (!productId) return {};
            if (!cleverBridgeCartIDs?.length) return {};

            return this.promotionList.find((item) => {
                if (item.product_id !== productId) return false;
                return cleverBridgeCartIDs.find((id) => item.license_ids?.includes(id));
            }) || {};
        },
    },
};
